import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './header_image.less'

class HeaderImage extends React.Component {
  static propTypes = {
    src: PropTypes.string,
    isWideView: PropTypes.bool,
  }

  render() {
    if (!this.props.src) {
      return
    }

    return (
      <div
        styleName={`header-container ${
          this.props.isWideView ? 'wide-view-imag-container' : ''
        }`}
      >
        <img src={this.props.src} styleName="header-image" alt="header image" />
      </div>
    )
  }
}

export default cssModules(HeaderImage, styles, { allowMultiple: true })
